export default __webpack_public_path__ + "static/O0156-89987b677569bc179636cce9dea40780.png";